module.exports = __webpack_public_path__ + "static/media/dailyRoutine_zh_HK.a7454347.png";